import React, { useCallback, useMemo } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import classNames from 'classnames';
import { getNecessaryTimeFormat } from '../../../../utils/helpers/helpers';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import { useModal } from '../../../../hooks/useModal';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';
import { isNumber } from 'lodash';

const GamesRatingBox = React.forwardRef(function GamesRatingBox({ isGame, date, text, seasonDates, button }, ref) {
  const { addModal } = useModal();
  const { isArabic } = useLanguageControls();

  const modifiedDate = useMemo(
    () =>
      !date
        ? ''
        : ['start', 'end'].reduce(
            (acc, interval) =>
              acc.replace(
                `{{${interval}}}`,
                isNumber(seasonDates?.[interval]) ? getNecessaryTimeFormat(seasonDates?.[interval], isArabic) : '',
              ),
            date,
          ),
    [seasonDates, date, isArabic],
  );

  const clickPrizes = useCallback(() => {
    return addModal({ type: 'prizeModal', props: { isMonth: true, isGamesRatingPrizes: true } });
  }, []);

  return (
    <div className={classNames(`games__rating-box`, { 'games__rating-box_game': isGame })} ref={ref}>
      {date && <p className={`games__rating-box-date`}>{safeHTML(modifiedDate)}</p>}
      <p className={`games__rating-box-text`}>{safeHTML(text)}</p>
      <CustomButton {...button} onClick={clickPrizes} />
    </div>
  );
});

export default GamesRatingBox;
GamesRatingBox.propTypes = {};
